import React from "react";
import { ActionTypes } from "../action-type";

const initialState = {
    debates:null

}
   


export const getRemainingDebateReducer = (state=initialState,action)=>{
    switch(action.type){
        case ActionTypes.REMAINING_DEBATES:
            console.log(action.payload.debates,"from reducer")
            return {...state,debates:action.payload.debates
            }
        default:
            return state;
    }
    
}